<template>
  <x-dialog
    width="50%"
    :dialogTitle="dialogTitle"
    :dialogState="editBillingDialog"
    @toggleModal="closeDialog"
    :actions="{
      show: true,
      secondaryButtonFunction: closeDialog,
      primaryButtonFunction: saveBillingDetails,
      primaryButtonShow: true,
      secondaryButtonText: 'Cancel',
      primaryButtonText: 'Save changes'
    }"
    :data-test-id="dataTestId"
  >
    <template slot="dialog_data">
      <v-card-text class="px-10">
        <v-form v-model="formValid">
          <v-row align="center" no-gutters>
            <v-col md="3">
              <span class="formInputLabel mt-0">Enable billing email</span>
            </v-col>
            <v-col
              md="9"
              :data-test-id="`${dataTestId}__billing-email-toggle-btn-wrapper`"
            >
              <v-switch
                v-model="organisationBillingSetting.billingEmailEnabled"
                dense
                height="52px"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col md="3">
              <span class="formInputLabel mt-0">Email address</span>
            </v-col>
          </v-row>
          <v-row
            align="center"
            no-gutters
            :data-test-id="`${dataTestId}__email-input-wrapper`"
          >
            <v-text-field
              solo
              dense
              flat
              height="52px"
              background-color="#E5E5E5 !important"
              v-model="organisationBillingSetting.billingEmailAddress"
              :disabled="!organisationBillingSetting.billingEmailEnabled"
              :rules="[rules.email]"
            ></v-text-field>
          </v-row>
          <v-row align="center">
            <v-col md="3">
              <span class="formInputLabel">Currency</span>
            </v-col>
          </v-row>
          <v-row
            class="positionRelative"
            align="center"
            no-gutters
            :data-test-id="`${dataTestId}__currency-select-wrapper`"
          >
            <v-select
              :items="currencyType"
              solo
              dense
              flat
              v-model="organisationBillingSetting.currency"
              item-value="id"
              item-text="label"
              append-icon="keyboard_arrow_down"
              class="cursorPointer"
              background-color="#E5E5E5 !important"
              height="52px"
              :attach="
                `[data-test-id='${dataTestId}__currency-select-wrapper']`
              "
            ></v-select>
          </v-row>
          <v-row align="center">
            <v-col md="3">
              <span class="formInputLabel">Contract type</span>
            </v-col>
          </v-row>
          <v-row
            class="positionRelative"
            no-gutters
            align="center"
            :data-test-id="`${dataTestId}__contract-type-select-wrapper`"
          >
            <v-select
              :items="contractType"
              item-value="id"
              item-text="label"
              v-model="organisationBillingSetting.contractType"
              solo
              dense
              flat
              append-icon="keyboard_arrow_down"
              class="cursorPointer"
              background-color="#E5E5E5 !important"
              height="52px"
              :attach="
                `[data-test-id='${dataTestId}__contract-type-select-wrapper']`
              "
            ></v-select>
          </v-row>
          <v-row align="center">
            <v-col md="3">
              <span class="formInputLabel">Billing start date</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <DatePicker
              :setDate="selectedDate"
              solo
              dense
              flat
              :data-test-id="`${dataTestId}`"
            />
          </v-row>
        </v-form>
      </v-card-text> </template
  ></x-dialog>
</template>

<script>
import DatePicker from '@/components/Common/DatepickerRaw';
import EventBus from '@/EventBus';
import UserService from '../../../services/UserService';
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      formValid: false,
      rules: {
        email: v =>
          v.match(
            // eslint-disable-next-line
            /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
          ) || 'Please enter a valid email'
      },
      mailEnabled: true,
      selectedDate: new Date().toISOString(),
      dialogTitle: 'Edit billing details',
      darkTheme: null,
      editBillingDialog: false,
      organisationBillingSetting: {
        billingEmailAddress: '',
        billingEmailEnabled: false,
        billingStart: 0,
        contractType: '',
        currency: ''
      },
      currencyType: [
        {
          id: 'EUR',
          label: 'Euro'
        },
        {
          id: 'GBP',
          label: 'British Pound'
        },
        {
          id: 'USD',
          label: 'US Dollars'
        }
      ],
      contractType: [
        {
          id: 'PAYG',
          label: 'Pay as you go'
        },
        {
          id: 'MANUAL',
          label: 'Manual'
        },
        {
          id: 'YEAR_1',
          label: '1 year'
        },
        {
          id: 'YEAR_2',
          label: '2 year'
        }
      ],
      dataTestId: 'billing-details-dialog'
    };
  },
  props: ['showDialog', 'orgDetails'],
  created: function() {
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  mounted() {
    EventBus.$on('getUpdatedDataOnDateChange', value => {
      this.selectedDate = value;
    });
    this.editBillingDialog = this.showDialog;
    if (this.orgDetails.organisationBillingSetting !== null) {
      this.organisationBillingSetting = JSON.parse(
        JSON.stringify(this.orgDetails.organisationBillingSetting)
      );
      this.selectedDate = this.convertToUnixISOString({
        timestamp: this.organisationBillingSetting.billingStart
      });
    }
  },
  methods: {
    escapeKeyListener: function(evt) {
      if (evt.keyCode === this.escapeKeyCode && this.editBillingDialog) {
        this.closeDialog();
      }
    },
    async saveBillingDetails() {
      // add form validation
      try {
        // change date to timestamp
        let x = true;

        if (!x) {
          return false;
        }
        //        this.organisationBillingSetting.billingStart = this.selectedDate;
        if (!this.organisationBillingSetting.billingEmailEnabled) {
          this.organisationBillingSetting.billingEmailAddress = '';
        }
        this.organisationBillingSetting.billingStart = this.getUnixTimestamp({
          date: this.selectedDate
        });
        let requestObj = {
          organisationBillingSetting: this.organisationBillingSetting
        };
        await UserService.updateOrg({
          orgId: this.orgDetails.orgId,
          obj: requestObj
        });
        this.snackbar('success', this.$message.UPDATE_SUCCESS);
        this.closeDialog();
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    closeDialog() {
      this.editBillingDialog = false;
      this.$emit('closeOverlay', true);
    }
  }
};
</script>

<style scoped>
span {
  font-size: 16px;
}
</style>

<style>
.showDate {
  justify-content: center;
  align-items: center;
  display: flex;
  text-align: center;
  width: 100%;
  cursor: pointer;
}
</style>
